import { ScholarshipCategoryDto } from '@cradua/data';
import { createReducer, on, Action } from '@ngrx/store';
import { EntityState, EntityAdapter, createEntityAdapter } from '@ngrx/entity';

import * as ScholarshipCategoryActions from './scholarshipcategory.actions';

export const SCHOLARSHIP_CATEGORY_FEATURE_KEY = 'scholarshipcategory';

export interface ScholarshipCategoryState
  extends EntityState<ScholarshipCategoryDto> {
  selectedScholarshipCategoryId?: string | number; // which ScholarshipCategory record has been selected
  loaded: boolean; // has the ScholarshipCategory list been loaded
  error?: string | null; // last none error (if any)
}

export interface ScholarshipCategoryPartialState {
  readonly [SCHOLARSHIP_CATEGORY_FEATURE_KEY]: ScholarshipCategoryState;
}

export const scholarshipCategoryAdapter: EntityAdapter<ScholarshipCategoryDto> = createEntityAdapter<
  ScholarshipCategoryDto
>({
  selectId: (scholarshipCategory) => scholarshipCategory.id,
  sortComparer: false,
});

export const initialState: ScholarshipCategoryState = scholarshipCategoryAdapter.getInitialState(
  {
    // set initial required properties
    loaded: false,
    error: null,
    selectedScholarshipCategoryId: null,
  }
);

const scholarshipCategoryReducer = createReducer(
  initialState,
  on(ScholarshipCategoryActions.loadScholarshipCategory, (state) => ({
    ...state,
    loaded: true,
    error: null,
  })),
  on(
    ScholarshipCategoryActions.loadScholarshipCategorySuccess,
    (state, { scholarshipCategory }) =>
      scholarshipCategoryAdapter.addAll(scholarshipCategory, {
        ...state,
        loaded: false,
      })
  ),
  on(
    ScholarshipCategoryActions.loadScholarshipCategoryFailure,
    (state, { error }) => ({
      ...state,
      loaded: false,
      error,
    })
  ),
  on(ScholarshipCategoryActions.addScholarshipCategory, (state) => ({
    ...state,
    loaded: true,
    error: null,
  })),
  on(
    ScholarshipCategoryActions.addScholarshipCategorySuccess,
    (state, { newScholarshipCategory }) =>
      scholarshipCategoryAdapter.addMany(newScholarshipCategory, {
        ...state,
        loaded: false,
      })
  ),
  on(
    ScholarshipCategoryActions.addScholarshipCategoryFailure,
    (state, { error }) => ({
      ...state,
      loaded: false,
      error,
    })
  ),
  on(ScholarshipCategoryActions.updateScholarshipCategory, (state) => ({
    ...state,
    loaded: true,
    error: null,
  })),
  on(
    ScholarshipCategoryActions.updateScholarshipCategorySuccess,
    (state, { updateScholarshipCategory }) =>
      scholarshipCategoryAdapter.upsertMany(updateScholarshipCategory, {
        ...state,
        loaded: false,
      })
  ),
  on(
    ScholarshipCategoryActions.updateScholarshipCategoryFailure,
    (state, { error }) => ({
      ...state,
      loaded: false,
      error,
    })
  ),
  on(ScholarshipCategoryActions.removeScholarshipCategory, (state) => ({
    ...state,
    loaded: true,
    error: null,
  })),
  on(
    ScholarshipCategoryActions.removeScholarshipCategorySuccess,
    (state, { ids }) =>
      scholarshipCategoryAdapter.removeMany(ids, { ...state, loaded: false })
  ),
  on(
    ScholarshipCategoryActions.removeScholarshipCategoryFailure,
    (state, { error }) => ({
      ...state,
      loaded: false,
      error,
    })
  )
);

export function reducer(
  state: ScholarshipCategoryState | undefined,
  action: Action
) {
  return scholarshipCategoryReducer(state, action);
}
